/* Kindly: highlight open facts ([CONFIRM: ...], placeholders) and drive the offer tiers on the product page. */
(function () {
  var RE = /\[(?:CONFIRM|REVIEW PLACEHOLDER|FOUNDER STORY)[^\]]*\]/g;
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, NOSCRIPT: 1, TEMPLATE: 1 };

  function wrap(root) {
    if (!root || !document.createTreeWalker) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (!p || SKIP[p.nodeName] || (p.closest && p.closest('.kindly-confirm'))) return NodeFilter.FILTER_REJECT;
        RE.lastIndex = 0;
        return RE.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var text = n.nodeValue, frag = document.createDocumentFragment(), last = 0, m;
      RE.lastIndex = 0;
      while ((m = RE.exec(text))) {
        if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        var s = document.createElement('span');
        s.className = 'kindly-confirm';
        s.textContent = m[0];
        frag.appendChild(s);
        last = m.index + m[0].length;
      }
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      n.parentNode.replaceChild(frag, n);
    });
  }

  /* Offer tiers: chosen quantity per product section survives Dawn's quantity reset
     (variant change and add to cart call setQuantityBoundries, which sets the input to 1). */
  var chosen = {};

  function paint(sectionId, qty) {
    document.querySelectorAll('[data-kindly-tiers][data-section="' + sectionId + '"] [data-qty]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-qty')) === String(qty) ? 'true' : 'false');
    });
  }

  function applyQty(sectionId) {
    var qty = chosen[sectionId];
    var input = document.getElementById('Quantity-' + sectionId);
    if (!qty || !input || String(input.value) === String(qty)) return;
    input.value = qty;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function initTiers(scope) {
    (scope || document).querySelectorAll('[data-kindly-tiers]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var sectionId = box.getAttribute('data-section');
      if (chosen[sectionId]) paint(sectionId, chosen[sectionId]);
      box.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-qty]');
        if (!btn) return;
        chosen[sectionId] = btn.getAttribute('data-qty');
        paint(sectionId, chosen[sectionId]);
        applyQty(sectionId);
      });
    });
  }

  function watchQuantity() {
    /* Typed or +/- quantity: highlight the matching tier (or none) and remember it. */
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.id || t.id.indexOf('Quantity-') !== 0 || t.name !== 'quantity') return;
      var sectionId = t.id.slice('Quantity-'.length);
      if (!document.querySelector('[data-kindly-tiers][data-section="' + sectionId + '"]')) return;
      chosen[sectionId] = t.value;
      paint(sectionId, t.value);
    });
    /* Dawn publishes quantityUpdate right after it resets the input to its minimum. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.quantityUpdate, function () {
        Object.keys(chosen).forEach(applyQty);
      });
    }
  }

  function run() {
    wrap(document.body);
    initTiers(document);
    watchQuantity();
    if (window.MutationObserver) {
      var busy = false;
      new MutationObserver(function (list) {
        if (busy) return;
        busy = true;
        list.forEach(function (m) {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType === 1) { wrap(n); initTiers(n); }
            else if (n.nodeType === 3 && n.parentNode) wrap(n.parentNode);
          });
        });
        busy = false;
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
